import { ITrack, Track } from './track';
import { ISubdivsion, Subdivision } from './subdivision';

export class Location {
  subdivision: ISubdivsion;
  prefix: string;
  milepost: string;
  track: Track;
  range: number;

  constructor(location: ILocation) {
    this.subdivision = new Subdivision(location.subdivision);
    this.prefix = location.prefix;
    this.milepost = location.milepost;
    this.track = location.track === undefined ? undefined : new Track(location.track);
    this.range = location.range;
  }
}

export interface ILocation {
  subdivision: ISubdivsion;
  prefix: string;
  milepost: string;
  track: ITrack;
  range: number;
}
